module.exports = __webpack_public_path__ + "img/resume_active.5f9c136a.png";